import React from 'react'

import { BoxClosedOrderTabIcon } from './BoxClosedOrderTabIcon'
import { BoxOpenOrderTabIcon } from './BoxOpenOrderTabIcon'
import { CancelledOrderTabIcon } from './CancelledOrderTabIcon'
import { KnifeAndForkOrderTabIcon } from './KnifeAndForkOrderTabIcon'
import { TruckOrderTabIcon } from './TruckOrderTabIcon'
import type { OrderTab } from '../OrderTabs.types'

type OrderTabIconProps = {
  icon: OrderTab['icon']
}

export function OrderTabIcon({ icon }: OrderTabIconProps) {
  if (icon === 'boxClosed') {
    return <BoxClosedOrderTabIcon testId="order-tab-custom-icon-box-close" />
  }

  if (icon === 'boxOpen') {
    return <BoxOpenOrderTabIcon testId="order-tab-custom-icon-box-open" />
  }

  if (icon === 'cancelled') {
    return <CancelledOrderTabIcon testId="order-tab-custom-icon-cancelled" />
  }

  if (icon === 'knifeAndFork') {
    return <KnifeAndForkOrderTabIcon testId="order-tab-custom-icon-knife-and-fork" />
  }

  if (icon === 'truck') {
    return <TruckOrderTabIcon testId="order-tab-custom-icon-truck" />
  }

  return <BoxOpenOrderTabIcon testId="order-tab-custom-icon-box-open" />
}
